import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { Fragment, useEffect, useMemo, useState } from "react";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Checkbox from '@mui/material/Checkbox';
import InputAdornment from '@mui/material/InputAdornment';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import { styled, useTheme } from "@mui/material";
import DiscountIcon from '@mui/icons-material/Discount';
import { useI18N } from "../../context/I18NContext";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { useNavigate } from "react-router-dom";
import useWidgetStore from "../../store/useWidgetStore";
import useDataStore from "../../store/useDataStore";
import dayjs from 'dayjs';
import 'dayjs/locale/nl';
import 'dayjs/locale/en';
import 'dayjs/locale/fr';
import 'dayjs/locale/de';
import { CustomCheckboxElement, CustomTextFieldElement } from "../../layouts/Theme";
import { useVoucher } from "../../hooks/query/useVouchers";
import { useValidateVoucher } from "../../hooks/query/useValidateVoucher";
import { useFlow } from "../../context/FlowContext";
import { useSettings } from "../../context/SettingsContext";
import { FormContainer, FormErrorProvider, useForm } from "react-hook-form-mui";
import { createRow, moneyFormat, subtotal } from "../../helpers/general";
/**
 * A price or a quantity of zero tells the consumer nothing, so leave the cell empty rather than
 * printing "€ 0,-" or a bare 0. The cell itself stays, so the columns keep lining up.
 */
const showMoney = (value, prefix = '') => (value && value > 0 ? `${prefix}${moneyFormat(value)}` : '');
const showQty = (value) => (value && value > 0 ? String(value) : '');
const StyledTableCell = styled(TableCell)(({ theme }) => ({
    verticalAlign: 'top',
    textAlign: 'right',
    minWidth: '5em'
}));
export default function Cart({ fees, paymentMethod, deposit, canDeposit, useDeposit, setter, locked, canRedeem, setSubTotal, setErrorValidate, setSuccessValidate, successValidate, errorValidate }) {
    var _a, _b;
    const { t, ts } = useI18N();
    const theme = useTheme();
    const navigate = useNavigate();
    const { showSelectedResource, staticData, hasCheckout } = useSettings();
    const { apptypes, resources, products, } = useDataStore();
    const { booking, consumer, language, cart, setCart, selectedCapacity, selectedCapacityGroups, paymentOptions } = useWidgetStore();
    const flow = useFlow();
    const formContextVoucher = useForm({});
    const vouchersQuery = useVoucher();
    const validateVoucherQuery = useValidateVoucher(formContextVoucher);
    const { register, getValues, watch, formState: {} } = useForm();
    const [rows, setRows] = useState([]);
    const [expanded, setExpanded] = useState(false);
    const [vats, setVats] = useState([]);
    const [invoiceSubtotal, setInvoicesubtotal] = useState(0);
    const [invoiceTotalMinusDiscounts, setInvoiceTotalMinusDiscounts] = useState(0);
    const [chargeTotal, setChargeTotal] = useState(0);
    const [alternativePayment, setAlternativePayment] = useState(false);
    const [giftcards, setGiftcards] = useState();
    const [coupons, setCoupons] = useState();
    const [requiresAdditionalPayment, setRequiresAdditionalPayment] = useState(false);
    const [requiredSubscription, setRequiredSubscription] = useState();
    const [requiredSubscriptions, setRequiredSubscriptions] = useState(0);
    const [requiredSubscriptionsTotal, setRequiredSubscriptionsTotal] = useState(0);
    const [invoiceTotal, setInvoiceTotal] = useState(0);
    const [showDetails, setShowDetails] = useState(false);
    const [hasCode, setHasCode] = useState(false);
    const [onlyDeposit, setOnlyDeposit] = useState(false);
    const isLarge = useMediaQuery(theme.breakpoints.up('sm'));
    // how many strippen the appointments cost, when paying with a strippenkaart
    const strips = ((_a = booking.appointments) === null || _a === void 0 ? void 0 : _a.length) * ((_b = requiredSubscription === null || requiredSubscription === void 0 ? void 0 : requiredSubscription.charge) !== null && _b !== void 0 ? _b : 1);
    useEffect(() => {
        if ((paymentOptions === null || paymentOptions === void 0 ? void 0 : paymentOptions.deposit) || (paymentOptions === null || paymentOptions === void 0 ? void 0 : paymentOptions.full)) {
            if (!(paymentOptions === null || paymentOptions === void 0 ? void 0 : paymentOptions.full)) {
                setOnlyDeposit(true);
                if (setter) {
                    setter(true);
                }
            }
            else {
                setOnlyDeposit(false);
                if (setter) {
                    setter(false);
                }
            }
        }
    }, [paymentOptions]);
    watch(() => {
        setHasCode(getValues('code').length > 0);
    }, ['code']);
    useEffect(() => {
        vouchersQuery.refetch();
    }, [booking.appointments]);
    useEffect(() => {
        if (vouchersQuery.data) {
            let vouchers = vouchersQuery.data.result.items;
            let usableGiftcards = vouchers.filter((voucher) => voucher.type === 'giftCard' && voucher.valid);
            let usableVouchers = vouchers.filter((voucher) => voucher.type === 'discount' && voucher.valid && voucher.value > 0);
            setGiftcards(usableGiftcards);
            setCoupons(usableVouchers);
            if (usableVouchers.length > 0) {
                let _discounts = cart.discounts;
                setCart(Object.assign(Object.assign({}, cart), { discounts: _discounts, giftCards: usableGiftcards }));
            }
        }
    }, [vouchersQuery.data]);
    useEffect(() => {
        if (validateVoucherQuery.data && !validateVoucherQuery.isFetching) {
            if (validateVoucherQuery.data.status.status === 'failed') {
                if (validateVoucherQuery.data.status.userMessages) {
                    let _errors = [];
                    _errors.push(validateVoucherQuery.data.status.message);
                    Object.values(validateVoucherQuery.data.status.userMessages).map((error, i) => {
                        _errors.push(error);
                    });
                    setErrorValidate(_errors);
                }
                else {
                    setErrorValidate([validateVoucherQuery.data.status.message]);
                }
            }
            else {
                if (!validateVoucherQuery.data.result.item.valid) {
                    setErrorValidate([validateVoucherQuery.data.result.item.title]);
                }
                else {
                    let item = validateVoucherQuery.data.result.item;
                    if (item.type === "discount" && cart.discounts.length > 0) {
                        setErrorValidate([t("Je kunt maar 1 korting per bestelling toepassen", "payment")]);
                    }
                    else {
                        setSuccessValidate([validateVoucherQuery.data.result.item.title.concat(' ').concat(t('toegepast'))]);
                        if (item.type === "discount") {
                            setCart(Object.assign(Object.assign({}, cart), { discounts: [...cart.discounts, validateVoucherQuery.data.result.item] }));
                        }
                        else if (item.type === "giftCard") {
                            let newGiftCard = validateVoucherQuery.data.result.item;
                            newGiftCard.active = true;
                            setCart(Object.assign(Object.assign({}, cart), { giftCards: [...cart.giftCards, newGiftCard], discounts: [...cart.discounts, newGiftCard] }));
                        }
                    }
                    formContextVoucher.setValue('code', '');
                    setHasCode(false);
                }
            }
        }
    }, [validateVoucherQuery.isFetched, validateVoucherQuery.isFetching, validateVoucherQuery.isRefetching]);
    //  2APE QC
    useEffect(() => {
        // we have removed a giftcard use, add it to the list of available giftcards again
        // or we have added a new giftcard code
        if (giftcards && giftcards.length > 0 && cart.giftCards.length != (giftcards === null || giftcards === void 0 ? void 0 : giftcards.length)) {
            // @ts-ignore
            setGiftcards(cart.giftCards);
        }
    }, [cart.giftCards, giftcards]);
    useEffect(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        let _rows = [];
        let appointmentProductLines = cart.lines.filter((line) => line.productType === 'appointment');
        if (appointmentProductLines.length === 0) {
            let appointment = undefined;
            if ((booking === null || booking === void 0 ? void 0 : booking.appointments) && (booking === null || booking === void 0 ? void 0 : booking.appointments.length) > 0) {
                appointment = booking.appointments[0];
                //  booking.appointments.map((appointment) => {
                let dateStr = dayjs(appointment.date).locale(language).format('dddd D MMMM HH:mm');
                // and yes this is very much temporary to get the first widget ready ( HOW PROPHETIC!)
                let appTypeNames = [];
                (_a = appointment.components[0]) === null || _a === void 0 ? void 0 : _a.appointmentTypes.forEach((apptypeId) => {
                    let apptype = apptypes.find((apptype) => apptype.id === apptypeId);
                    if (apptype) {
                        appTypeNames.push(apptype.name);
                    }
                });
                let resourceNames = [];
                if (showSelectedResource) {
                    (_b = appointment.components[0]) === null || _b === void 0 ? void 0 : _b.resources.forEach((resourceId) => {
                        let resource = staticData.resources.find((resource) => {
                            return resource.id === resourceId;
                        });
                        if (resource) {
                            resourceNames.push(resource.name);
                        }
                    });
                }
                let capacities = [];
                if (selectedCapacity > 1) {
                    if (selectedCapacityGroups[0]) {
                        capacities.push(ts('%capacity% personen', { capacity: selectedCapacity.toString() }, 'summary'));
                    }
                    else {
                        const view = flow.views.find((view) => {
                            var _a;
                            const groups = (_a = view === null || view === void 0 ? void 0 : view.components) === null || _a === void 0 ? void 0 : _a.find((component) => {
                                if (component.picker === 'capacity') {
                                    return component.config.groups;
                                }
                                return undefined;
                            });
                            return groups === null || groups === void 0 ? void 0 : groups.config.groups;
                        });
                        const groups = (_c = view === null || view === void 0 ? void 0 : view.components) === null || _c === void 0 ? void 0 : _c.find((component) => {
                            if (component.picker === 'capacity') {
                                return component.config.groups;
                            }
                            return undefined;
                        });
                        for (const [_key, _value] of Object.entries(selectedCapacityGroups)) {
                            if (_key !== '0' && _value > 0) {
                                let groupName = groups === null || groups === void 0 ? void 0 : groups.config.groups.find((group) => group.id === parseInt(_key)).name;
                                capacities.push(ts('%capacity% %groupName%', { capacity: _value, groupName: t(groupName, 'select') }, 'summary'));
                            }
                        }
                    }
                }
                let desc = [];
                booking.appointments.map((_appointment) => {
                    let dateStr = dayjs(_appointment.date).locale(language).format('dddd D MMMM HH:mm');
                    desc.push(dateStr);
                });
                desc.push(appTypeNames.join(', '));
                if (resourceNames.length > 0) {
                    // if the selected resource was -1 or null, this row won't be added
                    desc.push(resourceNames.join(', '));
                }
                if (capacities.length > 0) {
                    desc.push(capacities.join(', '));
                }
                if (appTypeNames.length > 0) {
                    _rows.push(createRow(desc, appointment.price, booking.appointments.length, 0, //   21,
                    "appointment", "appointment"));
                }
                // })
            }
        }
        let firstAppointment = true;
        appointmentProductLines.map((line) => {
            var _a, _b, _c;
            // should always be 1 , for now 
            // nope, we have multiple now
            if (line.productType === 'appointment') {
                let appointment = booking.appointments.find((appointment) => appointment.id === line.appointmentId);
                if (!appointment) {
                    appointment = booking.appointments[0];
                }
                if (appointment) {
                    if (firstAppointment) {
                        let dateStr = dayjs(appointment.date).locale(language).format('dddd D MMMM HH:mm');
                        let appTypeNames = [];
                        (_a = appointment.components[0]) === null || _a === void 0 ? void 0 : _a.appointmentTypes.forEach((apptypeId) => {
                            let apptype = apptypes.find((apptype) => apptype.id === apptypeId);
                            if (apptype) {
                                appTypeNames.push(apptype.name);
                            }
                        });
                        let resourceId = (_b = appointment.components[0]) === null || _b === void 0 ? void 0 : _b.resources[0];
                        let resource = resources.find((resource) => resource.id === resourceId);
                        //if (apptype) {
                        _rows.push(createRow([
                            dateStr,
                            appTypeNames.join(', '),
                            resource ? resource === null || resource === void 0 ? void 0 : resource.name : ''
                        ], (_c = line === null || line === void 0 ? void 0 : line.originalPrice) !== null && _c !== void 0 ? _c : line.price, booking.appointments.length, 0, //   21,
                        "appointment", "appointment"));
                        //}
                        firstAppointment = false;
                    }
                }
            }
        });
        let otherProductLines = cart.lines.filter((line) => line.productType !== 'appointment');
        otherProductLines.map((line) => {
            var _a, _b, _c;
            _rows.push(createRow([
                line.name
            ], (_a = line === null || line === void 0 ? void 0 : line.originalPrice) !== null && _a !== void 0 ? _a : line.price, (_b = line.quantity) !== null && _b !== void 0 ? _b : 1, 0, //   21,
            line.productType, (_c = line.origin) !== null && _c !== void 0 ? _c : "optionalPurchase"));
        });
        setRows(_rows);
        let _subtotal = subtotal(_rows);
        setInvoicesubtotal(_subtotal);
        // if (paymentMethod === 'none' || paymentMethod?.startsWith('membership_')) {
        if (paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.startsWith('membership_')) {
            let subscription = (_d = consumer === null || consumer === void 0 ? void 0 : consumer.subscriptions) === null || _d === void 0 ? void 0 : _d.find((subscription) => subscription.id === parseInt(paymentMethod.substring(11)));
            setChargeTotal(0);
            let total = (subscription === null || subscription === void 0 ? void 0 : subscription.subscriptionId)
                ? 0
                : (_e = (paymentMethod.endsWith('_mandate') ? subscription === null || subscription === void 0 ? void 0 : subscription.initialFee : subscription === null || subscription === void 0 ? void 0 : subscription.sellPrice)) !== null && _e !== void 0 ? _e : 0;
            if (total < 0)
                total = 0;
            setInvoiceTotal(total);
            setInvoiceTotalMinusDiscounts(total);
            let parts = [(_f = subscription === null || subscription === void 0 ? void 0 : subscription.title) !== null && _f !== void 0 ? _f : ''];
            if (paymentMethod.endsWith('_mandate'))
                parts.push(t('met machtiging'));
            if (paymentMethod.endsWith('_mandate') && (subscription === null || subscription === void 0 ? void 0 : subscription.initialFee))
                parts.push(t('eenmalige kosten'));
            setAlternativePayment(parts.join(', '));
            setShowDetails(total > 0 && !(subscription === null || subscription === void 0 ? void 0 : subscription.mandatable));
        }
        else if (paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.startsWith('subscription_')) {
            let subscription = (_g = consumer.subscriptions) === null || _g === void 0 ? void 0 : _g.find((subscription) => subscription.id === parseInt(paymentMethod.substring(13).replace('_addPayment', '').replace('_addSubscription', '')));
            if (subscription === null || subscription === void 0 ? void 0 : subscription.subscriptionId) {
                if (subscription.charge) {
                    let charge = subscription.charge * (booking === null || booking === void 0 ? void 0 : booking.appointments.length);
                    if (charge > subscription.balance) {
                        // todo: is a balance of -1 a thing?
                        let remainder = (charge - subscription.balance) / subscription.charge;
                        charge = subscription.balance;
                        setRequiresAdditionalPayment(true);
                        let _remainingRows = Array.from(_rows);
                        _remainingRows.map((row) => {
                            if (row.type === "appointment") {
                                row.qty = remainder;
                                row.price = row.unit * remainder;
                            }
                            return row;
                        });
                        _subtotal = subtotal(_remainingRows);
                        setInvoiceTotal(_subtotal);
                        let requires = booking.appointments.length * subscription.charge, requiredCredits = requires - subscription.balance, requiredSubscriptions = Math.ceil(requiredCredits / subscription.max);
                        setRequiredSubscription(subscription);
                        setRequiredSubscriptions(requiredSubscriptions);
                        setRequiredSubscriptionsTotal(requiredSubscriptions * subscription.sellPrice);
                        if (paymentMethod.endsWith('addSubscription')) {
                            setInvoiceTotal(requiredSubscriptions * subscription.sellPrice);
                        }
                    }
                    setChargeTotal(charge);
                }
                else {
                    setChargeTotal(0);
                }
                setShowDetails(true);
            }
            else {
                if (subscription) {
                    let requiredCredits = booking.appointments.length * subscription.charge, requiredSubscriptions = Math.ceil(requiredCredits / subscription.max);
                    setRequiredSubscription(subscription);
                    setRequiredSubscriptions(requiredSubscriptions);
                    setRequiredSubscriptionsTotal(requiredSubscriptions * subscription.sellPrice);
                    let total = ((subscription === null || subscription === void 0 ? void 0 : subscription.subscriptionId) ? 0 : ((_h = subscription === null || subscription === void 0 ? void 0 : subscription.sellPrice) !== null && _h !== void 0 ? _h : 0)) * requiredSubscriptions;
                    if (total < 0)
                        total = 0;
                    setInvoiceTotal(total);
                    setInvoiceTotalMinusDiscounts(total);
                    setAlternativePayment((_j = subscription === null || subscription === void 0 ? void 0 : subscription.title) !== null && _j !== void 0 ? _j : false);
                    setChargeTotal(0);
                    setShowDetails(total > 0);
                }
            }
        }
        else if (paymentMethod === "alternate") {
            setShowDetails(false);
        }
        else {
            let total = (useDeposit && deposit ? deposit : _subtotal)
                + vatstotal(_rows)
                + feestotal(_rows);
            setInvoiceTotalMinusDiscounts(total);
            if (!useDeposit) {
                total -= discountstotal(_rows);
                if (total < 0)
                    total = 0;
            }
            setInvoiceTotal(total);
            setChargeTotal(0);
            if (_subtotal > 0)
                setShowDetails(true);
            setAlternativePayment(false);
            if (setSubTotal) {
                setSubTotal(total);
            }
        }
    }, [apptypes, resources, products, booking, cart, fees, deposit, useDeposit, paymentMethod]);
    useEffect(() => {
        if (setSubTotal) {
            setSubTotal(invoiceTotal);
        }
    }, [invoiceTotal]);
    useEffect(() => {
        if (setSubTotal) {
            setSubTotal(invoiceTotal);
        }
    }, []);
    const handleRowClick = (event) => {
        let value = event.currentTarget.getAttribute('rel');
        if (expanded === value) {
            setExpanded(false);
        }
        else {
            setExpanded(value);
        }
    };
    const deleteDiscount = (event) => {
        //@ts-ignore
        setCart(Object.assign(Object.assign({}, cart), { discounts: cart.discounts.filter(a => a.id !== event.target.closest('button').getAttribute('data-rel')) }));
    };
    const deleteGiftcard = (event) => {
        var _a;
        // uncheck, and remove it from the summary
        handleGiftcard(parseInt((_a = event.target.closest('button').getAttribute('data-rel')) !== null && _a !== void 0 ? _a : "0"), false);
    };
    const onSubmitVoucher = (data, event) => {
        let checkGift = cart.giftCards.find((giftcard) => { var _a; return giftcard.code.toUpperCase() === ((_a = data.code) === null || _a === void 0 ? void 0 : _a.toUpperCase().replace(' ', '')); });
        let checkCoupon = cart.discounts.find((discount) => { var _a; return discount.code.toUpperCase() === ((_a = data.code) === null || _a === void 0 ? void 0 : _a.toUpperCase().replace(' ', '')); });
        if (checkGift || checkCoupon) {
            setErrorValidate([t("Je hebt deze code al toegepast.")]);
        }
        else {
            if (!validateVoucherQuery.isFetching) {
                validateVoucherQuery.refetch();
            }
        }
    };
    const goTo = (e) => {
        let target = e.target.closest('button');
        let path = target.getAttribute('rel');
        navigate(`/oa_widget_${path}`);
    };
    const renderVats = useMemo(() => {
        return (_jsx(_Fragment, { children: vats === null || vats === void 0 ? void 0 : vats.map((value, i) => {
                return (_jsxs(TableRow, { sx: {
                        backgroundColor: theme.palette.background.default
                    }, children: [_jsx(TableCell, { children: t('BTW') }), _jsx(TableCell, { align: "right", children: `${(value.rate).toFixed(0)} %` }), _jsx(TableCell, { align: "right", children: showMoney(value.total) }), isLarge && (_jsx(TableCell, {}))] }, i));
            }) }));
    }, [vats]);
    const renderDiscounts = useMemo(() => {
        if (!cart || !cart.discounts || alternativePayment) {
            return (_jsx(_Fragment, {}));
        }
        let remaining = invoiceTotalMinusDiscounts;
        // make sure we use the coupons first, then use giftcards for anything remaining
        let _discounts = cart.discounts.sort((a, b) => {
            return a.type === 'discount' && b.type !== 'discount' ? -1 : 1;
        });
        return (_jsx(_Fragment, { children: _discounts === null || _discounts === void 0 ? void 0 : _discounts.map((discount, i) => {
                var _a;
                let value = discount.type === "giftCard" ? ((_a = discount.balance) !== null && _a !== void 0 ? _a : 0) : discount.value;
                if (value > remaining)
                    value = remaining;
                remaining -= value;
                if (discount.type === 'giftCard') {
                    if (!canRedeem) {
                        return _jsx(Fragment, {}, i);
                    }
                    let usable = giftcards === null || giftcards === void 0 ? void 0 : giftcards.find((giftcard) => giftcard.id === discount.id), 
                    // code: string = usable ? '' : `( ${discount.code} )`
                    code = discount.code !== '' && !discount.code.startsWith('automatic_') ? `(${discount.code})` : '';
                    return (_jsxs(TableRow, { sx: {
                            backgroundColor: theme.palette.background.default
                        }, children: [_jsx(TableCell, { sx: {
                                    width: '1em',
                                    padding: 0
                                }, children: _jsx(IconButton, { onClick: deleteGiftcard, "data-rel": discount.id, "aria-label": "delete", children: _jsx(DeleteIcon, { sx: { color: theme.palette.text.secondary } }) }) }), _jsxs(TableCell, { colSpan: locked ? (isLarge ? 3 : 2) : (isLarge ? 2 : 1), children: [discount.title, " ", code] }), _jsx(StyledTableCell, { children: showMoney(value, '- ') })] }, i));
                }
                if (discount.type === 'discount' && value !== null && value > 0) {
                    let code = discount.code.startsWith('discountType_') || discount.code.startsWith('automatic_') ? '' : `(${discount.code})`;
                    if (!canRedeem && code !== "") {
                        return _jsx(Fragment, {}, i);
                    }
                    // we don't allow (automatic or not) discounts if we are buying a subscription to use as payment for the appointment
                    if (cart.lines.find((line) => ["subscription", "membership"].includes(line.productType))) {
                        return _jsx(Fragment, {}, i);
                    } // else is display automatic discounts whether redeem is enabled or not
                    return (_jsxs(TableRow, { sx: {
                            backgroundColor: theme.palette.background.default
                        }, children: [!discount.code.startsWith('discountType_') && (_jsx(TableCell, { sx: {
                                    width: '1em',
                                    padding: 0
                                }, children: _jsx(IconButton, { onClick: deleteDiscount, "data-rel": discount.id, "aria-label": "delete", children: _jsx(DeleteIcon, { sx: { color: theme.palette.text.secondary } }) }) })), _jsxs(TableCell, { colSpan: discount.code.startsWith('discountType_') ? (isLarge ? 3 : 2) : (isLarge ? 2 : 1), children: [discount.title, " ", code] }), _jsx(StyledTableCell, { children: showMoney(value, '- ') })] }, i));
                }
            }) }));
    }, [cart, cart.giftCards, giftcards, alternativePayment, invoiceTotalMinusDiscounts, canRedeem]);
    const handleGiftcard = (event, checked) => {
        var _a, _b;
        let discountId = typeof event === "number" ? event : parseInt((_b = (_a = event.target.closest('.MuiCheckbox-root')) === null || _a === void 0 ? void 0 : _a.getAttribute('rel')) !== null && _b !== void 0 ? _b : "0");
        let existing = cart.discounts.find((discount) => {
            return parseInt(discount.id) === discountId;
        });
        if (!existing && checked) {
            let discount = giftcards === null || giftcards === void 0 ? void 0 : giftcards.find((discount) => parseInt(discount.id) === discountId);
            if (discount) {
                setCart(Object.assign(Object.assign({}, cart), { discounts: [...cart.discounts, discount] }));
            }
        }
        if (existing && !checked) {
            setCart(Object.assign(Object.assign({}, cart), { discounts: cart.discounts.filter(discount => parseInt(discount.id) !== discountId) }));
        }
    };
    const renderGiftcards = useMemo(() => {
        if (!cart || !cart.discounts || alternativePayment) {
            return (_jsx(_Fragment, {}));
        }
        return (_jsx(_Fragment, { children: giftcards && (giftcards === null || giftcards === void 0 ? void 0 : giftcards.length) > 0 && (_jsxs(_Fragment, { children: [_jsx(Typography, { variant: "h6", sx: {
                            color: theme.palette.text.primary,
                            marginLeft: 1,
                            marginTop: 0,
                            fontSize: '1rem'
                        }, children: t('Jouw cadeaukaarten') }), _jsx(TableContainer, { component: Paper, sx: {
                            marginBottom: 4
                        }, children: _jsx(Table, { sx: { color: theme.palette.text.primary }, "aria-label": t('Jouw cadeaukaarten'), children: _jsx(TableBody, { sx: {
                                    "& .MuiTableCell-body": {
                                        fontSize: '1rem'
                                    }
                                }, children: giftcards === null || giftcards === void 0 ? void 0 : giftcards.map((discount, i) => {
                                    var _a;
                                    let value = (_a = discount.balance) !== null && _a !== void 0 ? _a : 0, checked = cart.discounts.map((discount) => discount.id).includes(discount.id), codeStr = discount.code !== '' && !discount.code.startsWith('automatic_') ? `(${discount.code})` : '';
                                    //if(value > invoiceTotal) value = invoiceTotal
                                    return (_jsxs(TableRow, { sx: {
                                            backgroundColor: theme.palette.background.default
                                        }, children: [_jsx(TableCell, { sx: {
                                                    width: '1em',
                                                    padding: 0
                                                }, children: _jsx(Checkbox, { disabled: !checked && invoiceTotal === 0, onChange: handleGiftcard, rel: discount.id, checked: checked, color: "default" }) }), _jsxs(TableCell, { children: [discount.title, " ", codeStr] }), _jsx(StyledTableCell, { children: showMoney(value) })] }, i));
                                }) }) }) })] })) }));
    }, [cart, cart.giftCards, alternativePayment, giftcards, booking.appointments, invoiceTotal, errorValidate, successValidate]);
    const renderRedeem = useMemo(() => {
        return (_jsx(_Fragment, { children: hasCheckout && invoiceTotal > 0 && showDetails && (_jsx(_Fragment, { children: _jsx(FormContainer, { formContext: formContextVoucher, onSuccess: onSubmitVoucher, onError: onError, children: _jsxs(FormErrorProvider, { onError: (error) => {
                            if (error.type === 'validate') {
                                console.log(error);
                            }
                            return t(error.type, 'error');
                        }, children: [_jsx(Typography, { variant: "h6", sx: {
                                    color: theme.palette.text.primary,
                                    marginLeft: 1,
                                    marginTop: 0,
                                    fontSize: '1rem'
                                }, children: t('Wil je een cadeaukaart of korting gebruiken?') }), _jsx(CustomTextFieldElement, Object.assign({ required: false, label: t('Kortingscode of cadeaukaart code'), type: "code" }, register('code'), { InputProps: {
                                    startAdornment: (_jsx(InputAdornment, { position: "start", children: _jsx(DiscountIcon, { sx: { color: theme.palette.text.secondary } }) }))
                                }, sx: { my: 1, marginBottom: 4 }, fullWidth: true })), hasCode && (_jsx(Button, { type: "submit", fullWidth: true, variant: "contained", sx: { marginBottom: 4 }, children: t('Code toevoegen') }))] }) }) })) }));
    }, [canRedeem, useDeposit, paymentMethod, cart, alternativePayment, giftcards, booking.appointments, invoiceTotal, hasCode, errorValidate, successValidate]);
    const renderFees = useMemo(() => {
        if (!fees || fees.length === 0) {
            return (_jsx(_Fragment, {}));
        }
        return (_jsx(_Fragment, { children: fees.map((fee, i) => {
                return (_jsxs(TableRow, { sx: {
                        backgroundColor: theme.palette.background.default
                    }, children: [_jsx(TableCell, { colSpan: locked ? (isLarge ? 3 : 2) : (isLarge ? 3 : 2), children: fee.name }), _jsx(StyledTableCell, { children: showMoney(fee.value) })] }, i));
            }) }));
    }, [fees]);
    // const priceRow = (qty: number, unit: number): number => {
    //     return qty * unit
    // }
    // const createRow = (desc: string[], unit: number, qty: number, vatrate: number, type: ProductType): Row => {
    //     let price: number = priceRow(qty ?? 1, unit ?? 0)
    //     return {
    //         desc: desc,
    //         unit: unit ?? 0,
    //         qty: qty ?? 1,
    //         price: price,
    //         vatrate: vatrate,
    //         type: type
    //     } as Row
    // }
    // const subtotal = (items: readonly Row[]): number => {
    //     return items.map(({ price }) => price).reduce((sum, i) => sum + i, 0)
    // }
    const vatstotal = (items) => {
        let total = 0;
        total = items.map(({ price, vatrate, qty }) => {
            let rowVat = price * qty * (vatrate / 100);
            // for now just 1 product in the cart
            setVats([{ rate: vatrate, total: rowVat }]);
            return rowVat;
        }).reduce((sum, i) => sum + i, 0);
        return total;
    };
    const discountstotal = (items) => {
        let total = 0;
        if (cart.lines.find((line) => ["subscription", "membership"].includes(line.productType))) {
            return total;
        }
        if (cart && cart.discounts && !alternativePayment) {
            total = cart.discounts.map((discount) => {
                var _a;
                return discount.type === "giftCard" ? ((_a = discount.balance) !== null && _a !== void 0 ? _a : 0) : discount.value;
            }).reduce((sum, i) => sum + i, 0);
        }
        return total;
    };
    const feestotal = (items) => {
        let total = 0;
        if (fees) {
            total = fees.map((fee) => {
                return fee.value;
            }).reduce((sum, i) => sum + i, 0);
        }
        return total;
    };
    const onError = (errors) => { };
    rows.sort((a, b) => { return a.type === "appointment" ? -1 : 1; });
    return (_jsxs(_Fragment, { children: [_jsx(TableContainer, { component: Paper, sx: {
                    marginBottom: 4
                }, children: _jsx(Table, { "aria-label": t('Overzicht van je reservering'), children: _jsxs(TableBody, { sx: {
                            "& .MuiTableCell-body": {
                                fontSize: '1rem'
                            }
                        }, children: [rows === null || rows === void 0 ? void 0 : rows.map((row, i) => (_jsxs(Fragment, { children: [_jsxs(TableRow, { rel: i.toString(), onClick: handleRowClick, sx: {
                                            backgroundColor: theme.palette.background.default
                                        }, children: [_jsx(TableCell, { colSpan: row.type === 'appointment' ? (isLarge ? 3 : 4) : 2, children: row.desc.map((line, i) => _jsx(Box, { sx: Object.assign({ fontSize: row.type === 'appointment' ? '1.25rem' : '1rem' }, (row.type === 'appointment' && i < booking.appointments.length && {
                                                        fontWeight: 700
                                                    })), children: line }, i)) }), row.type !== 'appointment' && row.qty > 0 && (_jsxs(_Fragment, { children: [_jsx(StyledTableCell, { sx: { minWidth: '2em' }, children: row.type === 'product'
                                                            // ? <OutlinedInput value={row.qty} type={"number"} sx={{ width: '3.5em' }} /> 
                                                            ? row.qty
                                                            : row.qty }), _jsx(StyledTableCell, { children: showMoney(row.price) })] })), isLarge && row.type === 'appointment' && (_jsx(TableCell, { sx: { width: '2em' }, align: "right", children: _jsx(_Fragment, { children: !locked && (_jsx(IconButton, { onClick: goTo, rel: 'index', "aria-label": "edit", size: "medium", children: _jsx(EditIcon, { sx: { color: theme.palette.text.secondary } }) })) }) }))] }, row.desc), row.type === 'appointment' && (_jsxs(_Fragment, { children: [_jsxs(TableRow, { sx: {
                                                    backgroundColor: theme.palette.background.default
                                                }, children: [_jsx(TableCell, { colSpan: 2, children: row.desc[booking.appointments.length] }), _jsx(StyledTableCell, { children: showQty(row.qty) }), _jsxs(StyledTableCell, { sx: { minWidth: '6em' }, children: [!(paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.endsWith('addSubscription')) && !(paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.startsWith('subscription_')) && !(paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.startsWith('membership_')) && (_jsx(_Fragment, { children: showMoney(row.price) })), (paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.startsWith('subscription_')) && (
                                                            // pluralise on the number actually shown, not on the charge per
                                                            // appointment: with no requiredSubscription the charge is undefined
                                                            // and every amount read as "strippen", including 1
                                                            _jsxs(_Fragment, { children: [strips, " ", t(strips === 1 ? 'strip' : 'strippen')] }))] })] }), (paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.endsWith('addSubscription')) && (_jsxs(TableRow, { sx: {
                                                    backgroundColor: theme.palette.background.default
                                                }, children: [_jsx(TableCell, { colSpan: 2, children: requiredSubscription === null || requiredSubscription === void 0 ? void 0 : requiredSubscription.title }), _jsx(StyledTableCell, { children: showQty(requiredSubscriptions) }), _jsx(StyledTableCell, { children: showMoney(requiredSubscriptionsTotal) })] })), requiredSubscriptions > 0 && (paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.startsWith('subscription')) && !(paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.endsWith('addSubscription')) && (_jsxs(TableRow, { sx: {
                                                    backgroundColor: theme.palette.background.default
                                                }, children: [_jsx(TableCell, { colSpan: 2, children: requiredSubscription === null || requiredSubscription === void 0 ? void 0 : requiredSubscription.title }), _jsx(StyledTableCell, { children: showQty(requiredSubscriptions) }), _jsx(StyledTableCell, { children: showMoney(requiredSubscriptionsTotal) })] }))] })), !isLarge && expanded === i.toString() && (_jsxs(TableRow, { sx: {
                                            backgroundColor: theme.palette.background.default
                                        }, children: [row.type === 'product' && (_jsx(_Fragment, {})
                                            // <TableCell colSpan={3} sx={{ padding: 0 }}>
                                            //     <Button fullWidth sx={{ marginBottom: 2 }} variant={"contained"} color={"error"}>{t('Product verwijderen')}</Button>
                                            // </TableCell>
                                            ), row.type === 'appointment' && (_jsx(TableCell, { colSpan: 3, sx: { padding: 0 }, children: _jsx(Button, { fullWidth: true, onClick: goTo, rel: 'index', sx: { marginBottom: 2 }, variant: "contained", color: "error", children: t('Afspraak wijzigen') }) }))] }))] }, i))), chargeTotal == 0 && showDetails && invoiceTotalMinusDiscounts > 0 && (_jsxs(_Fragment, { children: [!alternativePayment && invoiceSubtotal > 0 && (_jsxs(TableRow, { sx: {
                                            color: theme.palette.secondary.contrastText,
                                            backgroundColor: theme.palette.secondary.main,
                                        }, children: [_jsx(TableCell, { colSpan: isLarge ? 3 : 3, children: t('Totaal') }), _jsx(StyledTableCell, { children: showMoney(invoiceSubtotal) })] })), alternativePayment && invoiceTotal > 0 && (_jsxs(TableRow, { sx: {
                                            color: theme.palette.secondary.contrastText,
                                            backgroundColor: theme.palette.secondary.main,
                                        }, children: [_jsx(TableCell, { colSpan: isLarge ? 3 : 3, children: t('Totaal') }), _jsx(StyledTableCell, { children: showMoney(invoiceTotal) })] })), !alternativePayment && useDeposit && deposit && deposit > 0 && (_jsxs(TableRow, { sx: {
                                            color: theme.palette.secondary.contrastText,
                                            backgroundColor: theme.palette.secondary.main,
                                        }, children: [_jsx(TableCell, { colSpan: isLarge ? 3 : 3, children: t('Aanbetaling') }), _jsx(StyledTableCell, { children: showMoney(deposit) })] })), renderFees, !useDeposit && (_jsx(_Fragment, { children: renderDiscounts })), _jsxs(TableRow, { sx: {
                                            color: theme.palette.secondary.contrastText,
                                            backgroundColor: theme.palette.secondary.main
                                        }, children: [_jsx(TableCell, { colSpan: isLarge ? 3 : 3, sx: {
                                                    fontWeight: 'bold'
                                                }, children: t('Nog te betalen') }), _jsx(StyledTableCell, { align: "right", sx: {
                                                    fontWeight: 'bold',
                                                }, children: showMoney(invoiceTotal) })] })] })), chargeTotal > 0 && showDetails && (_jsxs(TableRow, { sx: {
                                    color: theme.palette.secondary.contrastText,
                                    backgroundColor: theme.palette.secondary.main
                                }, children: [_jsx(TableCell, { colSpan: isLarge ? 2 : 2, sx: {
                                            fontWeight: 'bold'
                                        }, children: t('Nog te betalen') }), _jsxs(StyledTableCell, { align: "right", colSpan: 2, sx: {
                                            fontWeight: 'bold'
                                        }, children: [chargeTotal, " ", t(chargeTotal === 1 ? 'strip' : 'strippen'), requiresAdditionalPayment && (_jsx(_Fragment, { children: invoiceTotal > 0 && _jsxs(_Fragment, { children: ["\u00A0+ ", moneyFormat(invoiceTotal)] }) }))] })] })), canDeposit && !onlyDeposit && setter && (_jsx(TableRow, { sx: {
                                    backgroundColor: theme.palette.background.default
                                }, children: _jsx(TableCell, { colSpan: isLarge ? 4 : 3, sx: { padding: 0 }, children: _jsx(FormContainer, { children: _jsx(FormErrorProvider, { onError: (error) => {
                                                if (error.type === 'validate') {
                                                    console.log(error);
                                                }
                                                return t(error.type, 'error');
                                            }, children: _jsx(CustomCheckboxElement, { sx: {
                                                    marginLeft: 1
                                                }, labelProps: {
                                                    sx: {
                                                        color: theme.palette.text.primary,
                                                        "& a": {
                                                            color: theme.palette.text.primary,
                                                        }
                                                    }
                                                }, onChange: (event, checked) => {
                                                    setter(checked);
                                                }, required: false, label: t('Alleen aanbetalen').concat(showMoney(deposit) ? ` (${showMoney(deposit)})` : ''), name: 'useDeposit' }) }) }) }) }))] }) }) }), canRedeem && !useDeposit && invoiceTotal > 0 && (alternativePayment || (!(paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.startsWith('membership')) && !(paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.startsWith('subscription')) && paymentMethod !== "alternate")) && (_jsxs(_Fragment, { children: [renderRedeem, renderGiftcards] }))] }));
}
